import { useQuery } from '@tanstack/react-query';
import { Dispatch } from 'redux';

import { requestHandler } from '../../api';
import { EvaluationDetail, EvaluationRow } from './types';
import { NodesAvailableResponse } from './types';

export async function fetchCreditLineEvaluations(
  dispatch: Dispatch,
): Promise<EvaluationRow[]> {
  const response = await requestHandler({
    method: 'get',
    url: `internal/decisionEngine/product/creditLine`,
    dispatch,
  });
  if (response) return response.data;
  return [];
}

export async function fetchCreditLineEvaluation(
  dispatch: Dispatch,
  id: number,
): Promise<EvaluationDetail | undefined> {
  const response = await requestHandler({
    method: 'get',
    url: `internal/decisionEngine/product/creditLine/${id}`,
    dispatch,
  });
  if (response) return response.data;
}

export const fetchDecisionEnginesAvailables = async (
  dispatch: Dispatch,
  revisionObjective: string,
) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/decisionEngine/availables?revisionObjective=${revisionObjective}`,
    dispatch,
  });
  if (response) return response.data;
};

export const createCreditLineEvaluation = async (
  dispatch: Dispatch,
  payload: unknown,
) => {
  const response = await requestHandler({
    method: 'post',
    url: 'internal/decisionEngine/creditLine',
    data: payload,
    dispatch,
  });
  if (response) return response.data;
};

export const selectDecisionEngineAsDefault = async (
  dispatch: Dispatch,
  engineId: number,
) => {
  const response = await requestHandler({
    method: 'put',
    url: `internal/decisionEngine/${engineId}/default`,
    dispatch,
  });
  if (response) return response.data;
};

export const getCreditLineFactoringSelectedDecisionEngines = async (
  dispatch: Dispatch,
) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/decisionEngine/creditLine/factoring/selected`,
    dispatch,
  });
  if (response) return response.data;
};

export const getNodesAvailable = (
  dispatch: Dispatch,
  revisionObjective: string | null,
) =>
  useQuery({
    queryKey: ['decisionEngine', 'nodesAvailable', revisionObjective],
    queryFn: async (): Promise<NodesAvailableResponse | undefined> => {
      const response = await requestHandler({
        method: 'get',
        url: `internal/decisionNode/availableNodes?revisionObjective=${revisionObjective}`,
        dispatch,
      });
      if (response) return response.data;
    },
    enabled: !!revisionObjective,
    staleTime: 1000 * 60 * 5,
    gcTime: 1000 * 60 * 5,
    retry: 1,
  });
